// @ts-ignore
import { IS_INTL } from '@/constants/global'
import { useAccountStore } from '@/stores/account'
import { clearData, isElectron } from '@/utils/common'
// @ts-ignore
import NProgress from 'nprogress'
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const router = createRouter({
  history:
    isElectron() || !IS_INTL
      ? createWebHashHistory(import.meta.env.BASE_URL)
      : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      redirect: 'desktop',
      children: [
        {
          path: 'desktop',
          name: 'desktop',
          component: () => import('@/views/DesktopView.vue')
        },
        {
          path: 'console',
          name: 'console',
          component: () => import('@/views/ConsoleView.vue')
        }
      ]
    },
    {
      path: '/update',
      name: 'update',
      component: () => import('@/views/UpdateDialog.vue')
    },
    {
      path: '/update-error',
      name: 'update-error',
      component: () => import('@/views/ErrorDialog.vue')
    },
    {
      path: '/update-progress',
      name: 'update-progress',
      component: () => import('@/views/UpdateProgress.vue')
    },

    {
      path: '/signup',
      name: 'login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/stripe',
      name: 'stripe',
      component: () => import('@/views/StripeRedirectView.vue')
    },
    {
      path: '/similar',
      name: 'similar',
      component: () => import('@/views/SimilarView.vue')
    },
    {
      path: '/network-error',
      name: 'network-error',
      component: () => import('@/views/NetworkError.vue')
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import('@/views/LoginRedirectView.vue')
    },
    {
      path: '/start',
      name: 'start',
      component: () => import('@/views/ClientStartView.vue')
    },
    {
      path: '/canvas',
      name: 'canvas',
      component: () => import('@/views/StageView.vue')
    }
  ]
})

router.beforeEach(async (to) => {
  NProgress.start()
  if (
    to.name !== 'login' &&
    to.name !== 'register' &&
    to.name !== 'stripe' &&
    to.name !== 'network-error' &&
    to.name !== 'welcome' &&
    to.name !== 'update' &&
    to.name !== 'update-error' &&
    to.name !== 'update-progress' &&
    to.name !== 'start'
  ) {
    if (!isAuthenticated()) {
      clearData()
      return '/signup'
    }
  }
})

router.afterEach(() => NProgress.done())

const isAuthenticated = (): boolean => {
  const accountStore = useAccountStore()
  const token = accountStore.token
  return !!token
}

export default router
